export default __webpack_public_path__ + "static/media/1985.e7110cd7.png";